import styles from "./invoiceRequestedModal.module.css";
import { useMemo } from "react";
import { Modal, ModalId } from "../../../../../features/ui";
import { FiscalDocument, FiscalDocumentStatus } from "../../../../fiscal-documents";
import { useNavigate } from "react-router-dom";
import { RoutePath, useRoutesHooks } from "../../../../../features/routes";
import { TableName } from "../../../../../tables";

type Props = {
    operationTable: TableName
    fiscalDocument: FiscalDocument
}

export const InvoiceRequestedModal = (props: Props) => {
    const { operationTable, fiscalDocument } = props

    const { getRoutePath } = useRoutesHooks()
    const navigate = useNavigate()

    const isAuthorized = useMemo(() => fiscalDocument.status === FiscalDocumentStatus.AUTHORIZED, [fiscalDocument.status])
    const isRejected = useMemo(() => fiscalDocument.status === FiscalDocumentStatus.REJECTED, [fiscalDocument.status])
    const title = useMemo(() => isAuthorized ? "Factura Emitida" : isRejected ? "Factura Rechazada" : "Factura Solicitada", [isAuthorized, isRejected])
    
    const renderBody = () => <div className={styles.body}>
        {isAuthorized ?
            "Se emitió la factura correctamente." :
            isRejected ?
                "La factura fue rechazada. Intentar nuevamente." :
                <p>
                    Se generó la solicitud de la factura correctamente, su estado actual es <strong>En Espera</strong>.
                    <br />
                    Estamos verificando la autorización automáticamente; el estado se actualizará solo en unos segundos.
                </p>
        }
    </div>

    const onSubmit = () => {
        navigate(`${getRoutePath(operationTable === TableName.SALE_ORDERS ? RoutePath.SALES : RoutePath.HOARDS, fiscalDocument.operationId)}/${RoutePath.INVOICE}`)
    }

    return (
        <Modal
            modalId={ModalId.INVOICE_REQUESTED}
            title={title}
            onSubmit={isRejected ? onSubmit : undefined}
            submitLabel="Regenerar Factura"
            submitIcon="file-earmark-check"
            submitKind="quinary"
            cancelLabel="Cerrar"
        >
            {renderBody()}
        </Modal>
    )
}
